import { Button, ButtonProps } from 'semantic-ui-react'
import './index.css'

const ScanditButton = (props: ButtonProps) => {
  return <Button className="scandit-blue" {...props} />
}

export default ScanditButton
